import ServiceAPI from "./serviceapi";

export async function carregarConfig(chave : string, tipo: string): Promise<any> {
  
  const config = {
    url: "/configusuario/carregar",
    data: {
     chave: chave,
     tipo: tipo
    }, config: {
      ignoreToast: true
    }
  };

  let configPersistido = await ServiceAPI.execNativeService(config);

  return configPersistido?.dataResponse?.valor ? JSON.parse(configPersistido.dataResponse.valor) : null;
}

export async function salvarConfig(chave : string, tipo: string, valor: string): Promise<any> {
  
  const config = {
    url: "/configusuario/salvar",
    data: {
     chave: chave,
     tipo: tipo,
     valor: valor
    }, config: {
      ignoreToast: true
    }
  };

  let configPersistido = await ServiceAPI.execNativeService(config);

  return configPersistido?.dataResponse?.valor ? JSON.parse(configPersistido.dataResponse.valor) : null;
}